// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1ndSq","header":"Messages_header__VP6cX"};